export const socialMediaPlatforms = Object.freeze({
  facebook: {
    platform: "facebook",
    label: "Facebook",
    icon: "components/v2/Modal/facebook.svg",
  },
  instagram: {
    platform: "instagram",
    label: "Instagram Post & Reel",
    icon: "components/v2/Modal/instagramReelAndPostIcon.svg",
  },
  instagramStory: {
    platform: "instagramStory",
    label: "Instagram Story",
    icon: "components/v2/Modal/instagramStory.svg",
  },
  linkedin: {
    platform: "linkedin",
    label: "Linkedin",
    icon: "components/v2/Modal/linkedin.svg",
  },
  twitter: {
    platform: "twitter",
    label: "X",
    icon: "components/v2/Modal/x.svg",
  },
  youtube: {
    platform: "youtube",
    label: "Youtube Post",
    icon: "components/v2/Modal/youtube.svg",
  },
  youtubeShorts: {
    platform: "youtubeShorts",
    label: "Youtube Shorts",
    icon: "components/v2/Modal/youtubeShorts.svg",
  },
  tiktok: {
    platform: "tiktok",
    label: "Tiktok",
    icon: "components/v2/Modal/tiktok.svg",
  },
  telegram: {
    platform: "telegram",
    label: "Telegram",
    icon: "components/v2/Modal/telegram.svg",
  },
  snapchatStory: {
    platform: "snapchatStory",
    label: "Snapchat Stories",
    icon: "components/v2/Modal/snapchat.svg",
  },
  snapchatSpotlight: {
    platform: "snapchatSpotlight",
    label: "Snapchat Spotlight",
    icon: "components/v2/Modal/snapchat.svg",
  },
});

export const socialMediaPlatformsdupe = Object.freeze({
  facebook: {
    platform: "facebook",
    label: "Facebook",
    icon: "components/v2/Modal/facebook.svg",
  },
  instagram: {
    platform: "instagram",
    label: "Instagram",
    icon: "components/v2/Modal/instagram.svg",
  },
});

export const captionLanguages = [
  {
    label: "English",
    value: "english",
  },
  {
    label: "Albanian",
    value: "albanian",
  },
  {
    label: "Amharic",
    value: "amharic",
  },
  {
    label: "Arabic",
    value: "arabic",
  },
  {
    label: "Armenian",
    value: "armenian",
  },
  {
    label: "Bengali",
    value: "bengali",
  },
  {
    label: "Bosnian",
    value: "bosnian",
  },
  {
    label: "Bulgarian",
    value: "bulgarian",
  },
  {
    label: "Burmese",
    value: "burmese",
  },
  {
    label: "Catalan",
    value: "catalan",
  },
  {
    label: "Chinese",
    value: "chinese",
  },
  {
    label: "Croatian",
    value: "croatian",
  },
  {
    label: "Czech",
    value: "czech",
  },
  {
    label: "Danish",
    value: "danish",
  },
  {
    label: "Dutch",
    value: "dutch",
  },
  {
    label: "Estonian",
    value: "estonian",
  },
  {
    label: "Finnish",
    value: "finnish",
  },
  {
    label: "French",
    value: "french",
  },
  {
    label: "Georgian",
    value: "georgian",
  },
  {
    label: "German",
    value: "german",
  },
  {
    label: "Greek",
    value: "greek",
  },
  {
    label: "Gujarati",
    value: "gujarati",
  },
  {
    label: "Hindi",
    value: "hindi",
  },
  {
    label: "Hungarian",
    value: "hungarian",
  },
  {
    label: "Icelandic",
    value: "icelandic",
  },
  {
    label: "Indonesian",
    value: "indonesian",
  },
  {
    label: "Italian",
    value: "italian",
  },
  {
    label: "Japanese",
    value: "japanese",
  },
  {
    label: "Kannada",
    value: "kannada",
  },
  {
    label: "Kazakh",
    value: "kazakh",
  },
  {
    label: "Korean",
    value: "korean",
  },
  {
    label: "Latvian",
    value: "latvian",
  },
  {
    label: "Lithuanian",
    value: "lithuanian",
  },
  {
    label: "Macedonian",
    value: "macedonian",
  },
  {
    label: "Malay",
    value: "malay",
  },
  {
    label: "Malayalam",
    value: "malayalam",
  },
  {
    label: "Marathi",
    value: "marathi",
  },
  {
    label: "Mongolian",
    value: "mongolian",
  },
  {
    label: "Norwegian",
    value: "norwegian",
  },
  {
    label: "Persian",
    value: "persian",
  },
  {
    label: "Polish",
    value: "polish",
  },
  {
    label: "Portuguese",
    value: "portuguese",
  },
  {
    label: "Punjabi",
    value: "punjabi",
  },
  {
    label: "Romanian",
    value: "romanian",
  },
  {
    label: "Russian",
    value: "russian",
  },
  {
    label: "Serbian",
    value: "serbian",
  },
  {
    label: "Slovak",
    value: "slovak",
  },
  {
    label: "Slovenian",
    value: "slovenian",
  },
  {
    label: "Somali",
    value: "somali",
  },
  {
    label: "Spanish",
    value: "spanish",
  },
  {
    label: "Swahili",
    value: "swahili",
  },
  {
    label: "Swedish",
    value: "swedish",
  },
  {
    label: "Tagalog",
    value: "tagalog",
  },
  {
    label: "Tamil",
    value: "tamil",
  },
  {
    label: "Telugu",
    value: "telugu",
  },
  {
    label: "Thai",
    value: "thai",
  },
  {
    label: "Turkish",
    value: "turkish",
  },
  {
    label: "Ukrainian",
    value: "ukrainian",
  },
  {
    label: "Urdu",
    value: "urdu",
  },
  {
    label: "Vietnamese",
    value: "vietnamese",
  },
];

export const facebookPrivacyOptions = [
  {
    label: "Public",
    value: "public",
  },
  {
    label: "Draft",
    value: "draft",
  },
];

export const youtubePrivacyOptions = [
  {
    label: "Public",
    value: "public",
  },
  {
    label: "Private",
    value: "private",
  },
  {
    label: "Unlisted",
    value: "unlisted",
  },
];

export const emercePublishSites = {
  MFL: "MFL",
  PFL: "PFL",
  PUSOP: "PUSOP",
  TVRI: "TVRI",
};

export const dailymotionPublishSites = {
  CHANNEL: "Channel",
  PLAYLIST: "Playlist",
};

export const MAX_SNAPCHAT_PUBLISH_DURATION = 300;
